/**
 * @param {string} value
 * @returns {string|undefined}
 */
function uppercase (value) {
  if (!value || typeof value !== 'string') return ''
  return value.toUpperCase()
}

module.exports = { uppercase }
